const STORAGE_KEY = 'digisaka.cropCalendar.intro.v1';

export function readCropCalendarIntroSeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeCropCalendarIntroSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* ignore */
  }
}
